import React from 'react'
import { useRecoilValue } from 'recoil'
import { Auth as AuthState } from '../../State/Auth'
import { AuthModal } from './AuthModal'

export const Auth: React.FC = ({ children }) => {
  const { adapter, department } = useRecoilValue(AuthState)
  return adapter && department ? <>{children}</> : <AuthModal />
}
